var Key;
(function (Key) {
    Key["End"] = "End";
    Key["Home"] = "Home";
    Key["Left"] = "ArrowLeft";
    Key["Right"] = "ArrowRight";
})(Key || (Key = {}));
const getNextFocusedTabIndex = (current, key, tabs) => {
    switch (key) {
        case Key.Home:
            return 0;
        case Key.End:
            return tabs.length - 1;
        case Key.Left:
            if (current - 1 < 0)
                return tabs.length - 1;
            return current - 1;
        case Key.Right:
            if (current + 1 >= tabs.length)
                return 0;
            return current + 1;
        default:
            return -1;
    }
};
export default getNextFocusedTabIndex;
//# sourceMappingURL=getNextFocusedTabIndex.js.map